import Container from "@components/Atomic/Container/Container";
import { Sections } from "@components/Sections/Sections";
import { SectionsProps } from "@components/Sections/withSections";
import { ComponentProps } from "@ts/components";
import { Styles } from "@ts/sanity";
import React from "react";

type ContainerProps = ComponentProps & {
  content?: SectionsProps;
  sections?: SectionsProps;
  styles: Styles[] | null;
  nested?: boolean;
};

const SectionContainer = ({
  content,
  nested,
  sections,
  styles,
}: ContainerProps) => {
  return (
    <Container
      as={nested ? "div" : "section"}
      styles={styles}
      data-component-type="section-container"
    >
      <Sections page={{ content: content ?? sections }} nested={true} />
    </Container>
  );
};

export default SectionContainer;
